import { Controller } from "@hotwired/stimulus"

// Ouvre/ferme le menu de navigation sur mobile.
export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }
}
